/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Describes device model capabilities
 * @export
 * @interface DeviceModelCapabilities
 */
export interface DeviceModelCapabilities {
    /**
     * Whether device supports touching
     * @type {boolean}
     * @memberof DeviceModelCapabilities
     */
    touch: boolean;
}

export function DeviceModelCapabilitiesFromJSON(json: any): DeviceModelCapabilities {
    return DeviceModelCapabilitiesFromJSONTyped(json, false);
}

export function DeviceModelCapabilitiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceModelCapabilities {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'touch': json['touch'],
    };
}

export function DeviceModelCapabilitiesToJSON(value?: DeviceModelCapabilities | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'touch': value.touch,
    };
}


